var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgSimpleHouse(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("g", {
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M16 8.25L23.5 16h-2.25v6H17.5v-4.5h-3V22h-3.75v-6H8.5L16 8.25zm0 1.437L10.858 15h.892v6h1.75v-4.5h5V21h1.75v-6h.891L16 9.687z"
  }), React.createElement("path", {
    d: "M21.25 22h-10.5 10.5zm-7.75 0v-1h5v1h-5z"
  })));
}

export default SvgSimpleHouse;